/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { ContentModuleModal, TextField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { TOOLBAR_ITEM } from '@atoms/RichTextEditor/constants';
import RichTextEditor from '@atoms/RichTextEditor';
import { transformApiFormErrors } from '@utils/form';
import BackgroundSelect from '@organisms/BackgroundSelect/index';

import Form from '../Form';

import Item from './Item';
import { FORM_FIELD, FORM_FIELDS } from './constants';
import RichTextField from '@components/molecules/RichTextField';

const FullWidthTextBlockModal = ({
  visible,
  hide,
  previewImg,
  onDelete,
  onSubmit,
  initialValues: data,
  errors,
  isUltimateDesign,
}) => {
  const [form] = Form.useForm(FORM_FIELDS);
  const initialValues = React.useMemo(() => form.deserialize(data), [data, form]);

  React.useEffect(() => {
    if (visible) {
      // Again a dirty hack to show error when modal opens first time because form is working on subscriptions.
      setTimeout(() => {
        form.setFields(transformApiFormErrors(errors?.content, FORM_FIELDS));
      });
    }
  }, [visible, errors, form]);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleOnValuesChange = ({ [FORM_FIELD.BACKGROUND.name]: backgroundImage }) => {
    if (backgroundImage) {
      form.setFieldsValue({
        [FORM_FIELD.BACKGROUND.name]: { id: backgroundImage.id, edited: backgroundImage.edited },
      });
    }
  };

  // Should be unique name, otherwise WYSIWYG editor won't work correctly if multiple text blocks are added
  const formName = React.useMemo(() => `form_in_modal-${Math.random()}`, []);

  return (
    <ContentModuleModal
      visible={visible}
      title="Full Width Text Block"
      subtitle="Add HTML by clicking on the code icon"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD HTML'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <Form
        form={form}
        initialValues={initialValues}
        onSerializedFinish={handleSubmit}
        onValuesChange={handleOnValuesChange}
        layout="vertical"
        name={formName}
      >
        {isUltimateDesign ? (
          <>
            <TextField {...FORM_FIELD.TITLE} />
            <TextField {...FORM_FIELD.URL} />
            <TextField {...FORM_FIELD.URL_TEXT} />
            <RichTextField {...FORM_FIELD.CONTENT} />
            <BackgroundSelect
              isImgBackground={!!data?.backgroundImageId}
              background={FORM_FIELD.BACKGROUND}
              backgroundColours={FORM_FIELD.BACKGROUND_COLOUR}
            />
          </>
        ) : (
          <Form.Item {...FORM_FIELD.CONTENT} style={NO_MARGIN_BOTTOM}>
            <RichTextEditor toolbarItems={[TOOLBAR_ITEM.CODE]} />
          </Form.Item>
        )}
      </Form>
    </ContentModuleModal>
  );
};

FullWidthTextBlockModal.Item = Item;

export default FullWidthTextBlockModal;
